var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickCancelStar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1033 1.81699C11.4701 1.07374 12.5299 1.07374 12.8967 1.81699L15.294 6.67446C15.4397 6.9696 15.7213 7.17417 16.047 7.2215L21.4075 8.00043C22.2277 8.11961 22.5553 9.12759 21.9617 9.70612L18.0828 13.4871C17.8471 13.7169 17.7396 14.0479 17.7952 14.3723L18.7109 19.7111C18.851 20.528 17.9936 21.151 17.26 20.7653L12.4653 18.2446C12.174 18.0915 11.826 18.0915 11.5347 18.2446L6.74006 20.7653C6.00643 21.151 5.149 20.528 5.28911 19.7111L6.2048 14.3723C6.26043 14.0479 6.15289 13.7169 5.9172 13.4871L2.03828 9.70612C1.44476 9.12759 1.77227 8.11961 2.59249 8.00043L7.95303 7.2215C8.27874 7.17417 8.56031 6.9696 8.70597 6.67446L11.1033 1.81699Z",
    fill: "#FFD467"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickCancelStar);
export default __webpack_public_path__ + "static/media/quick-cancel-star.271aa1d991fba20b3d220ce6ed5e085f.svg";
export { ForwardRef as ReactComponent };